<template>
    <b-navbar
        toggleable="lg"
        class="sidebar shadow container-main fixed"
    >
        <div class="d-flex">
            <b-navbar-brand
                to="/orders"
                class="mr-0"
            >
                <b-img
                    class="mr-3 cursor-pointer"
                    :src="logoSrc"
                />
            </b-navbar-brand>
            <country-sticker
                v-if="country"
                :code="country"
            />
        </div>
        <b-navbar-toggle target="nav-collapse" />
        <b-collapse
            v-if="isAuthenticated"
            id="nav-collapse"
            isNav
        >
            <b-navbar-nav
                v-if="isMobile"
                class="navbar-items"
            >
                <b-nav-item
                    v-for="route in menuList"
                    :key="route.name"
                    :to="route.path"
                    :active="setActiveRoute(route)"
                >
                    <div class="navbar-item">
                        <i
                            v-if="route.meta.icon"
                            :id="route.name"
                            :class="`icon-${route.meta.icon}`"
                            class="icon"
                        />
                        <span>{{ menuItemName(route.meta) }}</span>
                    </div>
                </b-nav-item>
            </b-navbar-nav>
            <b-navbar-nav class="navbar-buttons">
                <b-nav-text class="button-language">
                    <check-language />
                </b-nav-text>
                <b-nav-text
                    v-if="isDesktopOrTablet"
                    class="pr-1"
                >
                    <top-external-service />
                </b-nav-text>
                <b-nav-text class="px-md-2 d-flex">
                    <span class="username">{{ username }}</span>
                    <i
                        :title="$tc('main.header.logOut', 2)"
                        class="icon icon-logout cursor-pointer"
                        @click="logout"
                    />
                </b-nav-text>
            </b-navbar-nav>
        </b-collapse>
    </b-navbar>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import TopExternalService from '@/components/topMenu/ExternalService';
import CheckLanguage from '@/components/topMenu/CheckLanguage';
import window from '@/mixins/window';
import mainLocales from '@/locales/ru/main.js';

export default {
    name: 'TopMenu',

    components: {
        CheckLanguage,
        TopExternalService,
        CountrySticker: () => import(/* webpackChunkName: "CountrySticker" */ '@/components/topMenu/CountrySticker'),
    },

    props: {
        shortMenu: {
            type: Boolean,
            'default': false,
        },

        isAuthenticated: {
            type: Boolean,
            'default': false,
        },
    },

    inject: ['logout'],

    mixins: [window],

    computed: {
        ...mapState({
            menuList: state => state.menu.list,
        }),

        ...mapGetters(['country']),

        username() {
            return this.$store.getters.userName || '';
        },

        logoSrc() {
            return this.isDesktopOrTablet ? '/img/logo.svg' : '/img/logo-mini.svg';
        },
    },

    methods: {
        setActiveRoute(route) {
            return this.$route.matched[0] === route.matched[0];
        },

        menuItemName(routeMeta) {
            const mobileKey = routeMeta.menuTitle + 'Mobile';

            if (this.isMobile && mainLocales.menu[mobileKey]) {
                return this.$t(`main.menu.${mobileKey}`);
            } else {
                return this.$t(`main.menu.${routeMeta.menuTitle}`);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.navbar-text {
    color: #303030;
    line-height: 1.5em;
}

.navbar-buttons {
    display: flex;
    align-items: center;
    margin-left: auto;
}

.username {
    padding-left: 8px;
    margin-right: 8px;
    border-left: 1px solid #BDBDBD;
}

@media(max-width: 992px) {
    .navbar-buttons {
        margin-bottom: 16px;
        flex-direction: row;
        justify-content: flex-end;
    }
}

@media(max-width: 767px) {
    .navbar {
        box-shadow: 0px 2px 24px -8px rgba(112, 138, 176, 0.20) !important;
        background-color: #FFFFFF;
    }

    .navbar-toggler {
        margin: 15px 0;
        padding: 4px 12px;
        min-height: 40px;
        min-width: 56px;
    }

    .navbar-items {
        margin: 16px 0;
    }

    .nav-link {
        padding: 10px 12px;
        border-radius: 4px;
        min-height: 40px;
    }

    .navbar-item {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .navbar-text {
        padding: 4px 0;
    }

    .navbar-buttons {
        justify-content: space-between;
    }

    .icon {
        width: 20px;
        height: 20px;
    }

    .username {
        border-left: none;
        padding-left: 0;
    }

    .button-language {
        margin-left: 6px;
    }

    .fixed {
        position: fixed;
        top: 0;
        right: 0;
        left: 0;
        z-index: 1030
    }
}
</style>